var _circle, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChipCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57 10.998 58.858.781A49.745 49.745 0 0 1 79.4 9.552L73.414 18.2l9.9 9.9 8.337-5.772a49.71 49.71 0 0 1 7.567 18.815L89 43v14l10.218 1.858a49.717 49.717 0 0 1-7.803 19.165l-8.101-5.608-9.9 9.9 5.75 8.303a49.74 49.74 0 0 1-20.306 8.599L57 89H43l-1.857 10.217a49.751 49.751 0 0 1-20.825-8.977l5.774-8.34-9.9-9.9-7.952 5.506A49.71 49.71 0 0 1 .783 58.858L11 57V43L.782 41.142a49.708 49.708 0 0 1 7.41-18.579l8 5.539 9.9-9.9-5.821-8.408A49.752 49.752 0 0 1 41.142.78L43 10.998h14ZM50 86c19.882 0 36-16.118 36-36 0-19.883-16.118-36-36-36S14 30.117 14 50c0 19.882 16.118 36 36 36Z",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 100c27.614 0 50-22.386 50-50S77.614 0 50 0 0 22.386 0 50s22.386 50 50 50Zm0-4c25.405 0 46-20.595 46-46S75.405 4 50 4 4 24.595 4 50s20.595 46 46 46Z",
    fill: "#000",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.313 68.646a3.3 3.3 0 0 1 0-4.666l33.013-33.014a3.3 3.3 0 0 1 4.667 4.667L35.98 68.647a3.3 3.3 0 0 1-4.667 0Z",
    fill: "#302E31"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.966 30.967a3.3 3.3 0 0 1 4.667 0L68.647 63.98a3.3 3.3 0 0 1-4.666 4.667L30.965 35.634a3.3 3.3 0 0 1 0-4.667Z",
    fill: "#302E31"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 49.901,
    y1: 50.005,
    x2: 50.099,
    y2: 51.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 99,
    y1: 1,
    x2: 1,
    y2: 99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A494C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#302F31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A494C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipCancel);
export default __webpack_public_path__ + "static/media/chip-cancel.d0310771d1fe939ee6258bf66192f2de.svg";
export { ForwardRef as ReactComponent };